import moment from 'moment-timezone';
import { FEATURE_FLAGS, useAccountConfig } from '../../../../taboola-common-frontend-modules/account-configurations';
import { isStaticReport } from '../../../config/isStaticDynamicReport';

export const useDateRangeMaxLength = reportId => {
    const { [FEATURE_FLAGS.MAX_DATE_RANGE_LENGTH_MONTH]: maxLengthMonths } = useAccountConfig([
        FEATURE_FLAGS.MAX_DATE_RANGE_LENGTH_MONTH,
    ]);

    if (!maxLengthMonths || isStaticReport(reportId)) {
        return null;
    }

    const maxLengthDays = moment().diff(moment().subtract(maxLengthMonths, 'month'), 'days');

    return {
        maxLengthDays,
        maxLengthMonths,
    };
};
